module.exports = __webpack_public_path__ + "static/media/modal_background@3x.5fd38c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/modal_background@3x.png
// module id = 633
// module chunks = 0